import React, { useContext, useMemo } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import styled from 'styled-components';
import { StrategyPerSlotContext } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/context/context';

export function CondHeader() {
  const ctx = useContext(StrategyPerSlotContext);
  const {
    isGlobalFilterOpen,
    isGlobalFilterApplied,
    setIsGlobalFilterOpen,
    setProductCondSlotOpen,
  } = ctx;
  const num = useMemo(
    () => ctx.state?.slots?.findIndex((s) => s.num === ctx.productCondSlotOpen),
    [],
  );
  return (
    <CondHeaderStyled>
      <Back
        type="button"
        onClick={() =>
          isGlobalFilterOpen
            ? setIsGlobalFilterOpen(false)
            : setProductCondSlotOpen(undefined)
        }
      >
        <IoIosArrowBack color="grey" size={40} />
      </Back>
      <FilterDesc>
        {isGlobalFilterOpen ? (
          <>
            <p>Add Global Filter</p>
            <div>
              Global filters apply to all slots and update automatically across
              them
            </div>
          </>
        ) : (
          <>
            <p>
              {num >= 0 ? `Extra Filters for Slot ${num + 1}` : `More Filters`}
            </p>
            {isGlobalFilterApplied && (
              <div>
                Please note: Global filters are applied. Any additional filter
                you add will apply only to this slot
              </div>
            )}
          </>
        )}
      </FilterDesc>
    </CondHeaderStyled>
  );
}

const CondHeaderStyled = styled.div`
  position: relative;
  width: 100%;
  border-bottom: 3px #f5f5f5 solid;
  margin: 0 4rem;
  padding-bottom: 2rem;

  p {
    font-size: 3rem;
    margin: -2.5rem 0 1rem 0;
  }
`;
const Back = styled.button`
  &:hover {
    cursor: pointer;
    opacity: 0.3;
  }
  &:active {
    cursor: pointer;
    opacity: 0.5;
  }
  opacity: 0.5;
  left: 0;
  position: absolute;
  top: -30px;
  color: #d2d4d7;
`;

const FilterDesc = styled.div`
  p {
    font-size: 3rem;
    margin: -2.5rem 0 1rem 0;
  }

  div {
    background: #f5f5f5;
    text-align: left;
    padding: 1.3rem 3rem;
    font-size: 1.5rem;
    font-weight: 400;
    border-radius: 10px;
    margin-top: 2rem;
  }
`;
